module.exports = __webpack_public_path__ + "static/media/246-india.8a3036ba.svg";